import __request__ from "routing/request";
export function listInvestigationProcedures(investigationId, page = 1, per_page = 25, query, sort = "risk_max", direction = "desc", requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/investigations/${investigationId}/procedures`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listProcedureGroups(investigationId, procedureId, page = 1, per_page = 25, query, sort = "title", direction = "desc", requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/investigations/${investigationId}/procedures/${procedureId}`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listFormattedSteps(investigationId, procedureId, stepId, page = 1, per_page = 25, query, sort = "risk_max", direction = "desc", requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/investigations/${investigationId}/procedures/${procedureId}/steps/${stepId}/events`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
